import { render, staticRenderFns } from "./GroupListTable.vue?vue&type=template&id=58996763&scoped=true&"
import script from "./GroupListTable.vue?vue&type=script&lang=ts&"
export * from "./GroupListTable.vue?vue&type=script&lang=ts&"
import style0 from "./GroupListTable.vue?vue&type=style&index=0&id=58996763&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58996763",
  null
  
)

export default component.exports